export default "/dist/files/icone_religion.e44d40f813012ccd988b302eb05ef489.svg";